import { useMembersContext } from '@/contexts/membersContext';
import { InsuranceType } from '@/types/insuranceType';
import { QueryParams } from '@/types/query';
import ajax from '@/utils/ajax';

export const insuranceTypeRepository = {
  BASE_PATH: '/api/insurance/insurance_options/insurance_types/',

  async list(host: string, params: QueryParams): Promise<InsuranceType[]> {
    const response = await ajax.get({
      url: `${host}${this.BASE_PATH}`,
      params: {
        ...params
      }
    });

    return response.data;
  }
};

export const InsuranceTypeRepository = () => {
  const { host } = useMembersContext();

  return {
    async list(params: QueryParams) {
      return insuranceTypeRepository.list(host, params);
    }
  };
};
